// extracted by mini-css-extract-plugin
module.exports = {"news":"news_news__rw0Pf"};